/**
 * Frontend script for Биобиблиографический указатель.
 * PDF is displayed via PDF.js Viewer in an iframe (rendered by PHP).
 * This file is intentionally empty — all logic is in the iframe.
 */